import ReactDOM from 'react-dom'

import { getRoot } from 'utils/portal'

const PORTAL_ROOT_ID = 'app-portal'

export const TetherPortal = ({ children, isOpen = false }) => {
  const root = isOpen ? getRoot(PORTAL_ROOT_ID) : null

  if (!root) return null

  return ReactDOM.createPortal(children, root)
}
